// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"1603":"npm.core-js","3773":"npm.dompurify","7383":"npm.html2canvas","8727":"npm.canvg"}[chunkId] || chunkId) + "." + {"1603":"a75f08916bd64514f1cb","3773":"e2dbcfcc283539e7a4f5","4964":"aae416e5deeea950fbb5","7383":"e8b2433b6042fdfbc89c","8727":"ebf2dd648daf3baf2d72"}[chunkId] + ".js";
};